import { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { api } from '../lib/api';

const PlatformContext = createContext({ ordersEnabled: false, loading: true, refresh: () => {} });

export function PlatformProvider({ children }) {
  const [ordersEnabled, setOrdersEnabled] = useState(false);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const res = await api.getPlatformStatus();
      setOrdersEnabled(!!res.data.orders_enabled);
    } catch (e) {
      // Backend enforces regardless; keep pre-launch state on error
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return (
    <PlatformContext.Provider value={{ ordersEnabled, loading, refresh }}>
      {children}
    </PlatformContext.Provider>
  );
}

export const usePlatform = () => useContext(PlatformContext);
